function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.628906 11.082031 C 23.222656 11.082031 22.890625 11.414062 22.890625 11.824219 L 22.890625 25.339844 C 22.890625 26.765625 21.726562 27.929688 20.300781 27.929688 L 4.070312 27.929688 C 2.640625 27.929688 1.480469 26.765625 1.480469 25.339844 L 1.480469 9.109375 C 1.480469 7.679688 2.640625 6.519531 4.070312 6.519531 L 20.300781 6.519531 C 20.707031 6.519531 21.039062 6.1875 21.039062 5.777344 C 21.039062 5.371094 20.707031 5.039062 20.300781 5.039062 L 4.070312 5.039062 C 1.824219 5.039062 0 6.863281 0 9.109375 L 0 25.339844 C 0 27.582031 1.824219 29.410156 4.070312 29.410156 L 20.300781 29.410156 C 22.542969 29.410156 24.371094 27.582031 24.371094 25.339844 L 24.371094 11.824219 C 24.371094 11.414062 24.039062 11.082031 23.628906 11.082031 Z M 23.628906 11.082031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 29.328125 1.261719 C 28.4375 0.367188 26.984375 0.367188 26.09375 1.261719 L 13.417969 13.9375 C 13.398438 13.953125 13.207031 14.152344 13.160156 14.265625 L 11.402344 18.207031 C 11.277344 18.488281 11.339844 18.816406 11.554688 19.035156 C 11.699219 19.175781 11.886719 19.25 12.082031 19.25 C 12.183594 19.25 12.285156 19.230469 12.382812 19.1875 L 16.324219 17.429688 C 16.4375 17.382812 16.636719 17.191406 16.652344 17.171875 L 29.328125 4.496094 C 29.761719 4.0625 30 3.488281 30 2.878906 C 30 2.265625 29.761719 1.691406 29.328125 1.261719 Z M 28.28125 3.449219 L 15.605469 16.125 C 15.601562 16.128906 15.601562 16.132812 15.601562 16.132812 L 13.539062 17.050781 L 14.457031 14.988281 C 14.457031 14.988281 14.460938 14.988281 14.464844 14.984375 L 27.140625 2.308594 C 27.445312 2 27.976562 2 28.28125 2.308594 C 28.4375 2.460938 28.519531 2.660156 28.519531 2.878906 C 28.519531 3.09375 28.4375 3.296875 28.28125 3.449219 Z M 28.28125 3.449219 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.78ca04f81b2c4e94ec5655f1c7d6273b.svg";
export { ForwardRef as ReactComponent };